// /v3/analytics/network/:stationId/playsByGeo?userId=203825

import { DateRange } from '../../../Date/types';
import { getApiUrl } from '../../../Url';

const QUERY_KIND = 'playsByGeo';

export type GeoParameters = {
  geo1?: string;
  geo2?: string;
  geo3?: string;
  geo4?: string;
};
export type NetworkGeoLocationPlaysParameters = DateRange &
  GeoParameters & {
    webStationId: string;
    userId: number;
    resultGeo: string;
  };

export type NetworkGeoLocationPlaysResponse = {
  stationId: number;
  podcastNetwork: string;
  kind: 'playsByGeo';
  parameters: {
    timeRange: [number, number];
    timeInterval: number;
    geos: (string | null)[];
    resultGeo: string;
  };
  data: {
    rows: [number, string, number][];
    columnHeaders: [
      { name: 'Time (UTC)'; type: 'number' },
      { name: 'Geo'; type: 'string' },
      { name: 'Plays'; type: 'number' }
    ];
    assets: {
      flagUrlByGeo: { [key: string]: string };
    };
  };
};

export async function fetchNetworkGeoLocationPlays({
  webStationId,
  userId,
  startDateRange,
  endDateRange,
  resultGeo,
  geo1,
  geo2,
  geo3,
  geo4,
}: NetworkGeoLocationPlaysParameters): Promise<NetworkGeoLocationPlaysResponse> {
  try {
    const response = await fetch(
      getNetworkGeoLocationPlaysUrl({
        webStationId,
        userId,
        startDateRange,
        endDateRange,
        resultGeo,
        geo1,
        geo2,
        geo3,
        geo4,
      }),
      {
        method: 'GET',
        credentials: 'same-origin',
      }
    );
    if (response.ok) {
      return await response.json();
    }
    throw new Error(`Could not fetch this network's total plays`);
  } catch (err) {
    throw new Error(err.message);
  }
}

export function getNetworkGeoLocationPlaysUrl({
  webStationId,
  userId,
  startDateRange,
  endDateRange,
  resultGeo,
  geo1,
  geo2,
  geo3,
  geo4,
  csvFilename,
}: NetworkGeoLocationPlaysParameters & {
  csvFilename?: string;
}) {
  return getApiUrl({
    path: `analytics/network/:webStationId:${webStationId}/${QUERY_KIND}`,
    queryParameters: {
      userId,
      startDateRange,
      endDateRange,
      resultGeo,
      geo1,
      geo2,
      geo3,
      geo4,
      csvFilename,
    },
  });
}
